@if ((loadingValue$ | async); as progress) {
  @if (progress > 0) {
  @if ((branding$ | async); as branding) {
  <div class="center-loader">
    <img [src]="branding.loadingImage"
         [alt]="branding.companyName"
         class="center-loader__image" />
  </div>
  }
  }
}

<ngx-loading-bar color="#3173D6"
                 [includeSpinner]="false" />
